/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbEnveloppeProjetFinancementGridDto
 */
export interface FcbEnveloppeProjetFinancementGridDto {
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    idenveloppeProjetFinancement?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    idanneeScolaire?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    idprojetFinancement?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    heureS1?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    heureS2?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    identite?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbEnveloppeProjetFinancementGridDto
     */
    centre?: string | null;
}

/**
 * Check if a given object implements the FcbEnveloppeProjetFinancementGridDto interface.
 */
export function instanceOfFcbEnveloppeProjetFinancementGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbEnveloppeProjetFinancementGridDtoFromJSON(json: any): FcbEnveloppeProjetFinancementGridDto {
    return FcbEnveloppeProjetFinancementGridDtoFromJSONTyped(json, false);
}

export function FcbEnveloppeProjetFinancementGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbEnveloppeProjetFinancementGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idenveloppeProjetFinancement': !exists(json, 'idenveloppeProjetFinancement') ? undefined : json['idenveloppeProjetFinancement'],
        'idanneeScolaire': !exists(json, 'idanneeScolaire') ? undefined : json['idanneeScolaire'],
        'idprojetFinancement': !exists(json, 'idprojetFinancement') ? undefined : json['idprojetFinancement'],
        'heureS1': !exists(json, 'heureS1') ? undefined : json['heureS1'],
        'heureS2': !exists(json, 'heureS2') ? undefined : json['heureS2'],
        'identite': !exists(json, 'identite') ? undefined : json['identite'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
    };
}

export function FcbEnveloppeProjetFinancementGridDtoToJSON(value?: FcbEnveloppeProjetFinancementGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idenveloppeProjetFinancement': value.idenveloppeProjetFinancement,
        'idanneeScolaire': value.idanneeScolaire,
        'idprojetFinancement': value.idprojetFinancement,
        'heureS1': value.heureS1,
        'heureS2': value.heureS2,
        'identite': value.identite,
        'centre': value.centre,
    };
}

